<style scoped lang="css"></style>

<template>
  <div class="main-wrapper">
    <section class="section main-section bg-gradient-default min-vh-100 pt-3">
      <main class="container card shadow shadow-lg--hover mb-3" id="main">
        <Header title="Mi entrada" />
        <b-row class="mb-3">
          <b-col cols="6">
            <b-button-toolbar>
              <b-button variant="default" size="sm" @click="goBack">
                <b-icon-chevron-left scale="1.3" />
              </b-button>
            </b-button-toolbar>
          </b-col>
          <b-col cols="6">
            <b-button-toolbar class="float-right">
              <b-button-group> </b-button-group>
            </b-button-toolbar>
          </b-col>
        </b-row>
        <b-row class="mb-3">
          <b-col sm="12">
            <b-list-group>
              <b-list-group-item>
                Fecha registrada:
                {{ selectedCheck ? selectedCheck.datetime : "?" | datetime }},
                <small>
                  ({{
                    selectedCheck
                      ? selectedCheck.timestamp
                      : "?" | calendarFormat
                  }})
                </small>
              </b-list-group-item>
              <b-list-group-item>
                Marca de tiempo (UTC):
                {{ selectedCheck ? selectedCheck.timestamp : "?" }}
              </b-list-group-item>
              <b-list-group-item>
                <span>Tipo: </span>
                <b-badge
                  variant="success"
                  v-if="selectedCheck && selectedCheck.in"
                >
                  <span>
                    Entrada
                    <b-icon-box-arrow-in-right scale="1.4" />
                  </span>
                </b-badge>
                <b-badge variant="warning" v-else>
                  <span>
                    Salida
                    <b-icon-box-arrow-right scale="1.4" />
                  </span>
                </b-badge>
              </b-list-group-item>
              <b-list-group-item>
                Entrada de
                <b>{{ selectedCheck ? selectedCheck.email : "?" }}</b>
              </b-list-group-item>
              <b-list-group-item>
                Modificado por
                {{ selectedCheck ? selectedCheck.lastModifiedBy : "?" }}
              </b-list-group-item>
              <b-list-group-item>
                Precisión de ubicación:
                {{ selectedCheck ? selectedCheck.accuracy : "?" }} metros
              </b-list-group-item>
              <b-list-group-item>
                <GMap :config="mapConfig" :apiKey="mapApiKey">
                  <template slot-scope="{ google, map }">
                    <GMarker
                      :google="google"
                      :map="map"
                      :marker="checkMarker"
                    />
                  </template>
                </GMap>
              </b-list-group-item>
            </b-list-group>
          </b-col>
          <b-col> </b-col>
        </b-row>
      </main>
    </section>
  </div>
</template>

<script>
import moment from "moment";
import Header from "../Header";
import { mapGetters, mapMutations } from "vuex";
import { GOOGLE_MAPS_API_KEY } from "../store/common";
import GMap from "../maps/GoogleMapLoader";
import GMarker from "../maps/GoogleMapMarker";

moment.locale("es-us");

function checkToMarker(check) {
  if (!check) return {};
  return {
    id: check.timestamp,
    position: {
      lat: check.latitude,
      lng: check.longitude,
    },
    label: check.datetime,
    title: check.datetime,
  };
}

export default {
  name: "Check",
  components: {
    Header,
    GMap,
    GMarker,
  },
  data() {
    return {
      mapApiKey: GOOGLE_MAPS_API_KEY,
    };
  },
  mounted() {
    if (!this.hasSelected()) {
      this.goBack();
    }
  },
  computed: {
    ...mapGetters("checker", {
      selectedCheck: "getSelectedCheck",
    }),
    mapConfig() {
      return {
        zoom: 15,
        center: this.checkMarker ? this.checkMarker.position : undefined,
      };
    },
    checkMarker() {
      return checkToMarker(this.selectedCheck);
    },
  },
  methods: {
    ...mapGetters("checker", ["hasSelected"]),
    ...mapMutations("checker", {
      clearSelected: "CLEAR_SELECTED_CHECK",
    }),
    updateTime() {
      this.currentTimestamp = Date.now();
      this.$options.timer = setTimeout(this.updateTime, 1000);
    },
    goBack() {
      this.clearSelected();
      this.$router.push("/checks");
    },
  },
  filters: {
    calendarFormat(value) {
      return moment(value).calendar();
    },
    datetime(value) {
      return moment(value).locale("es").format("LLL Z");
    },
  },
};
</script>
